import Splide from '@splidejs/splide';

const EL = '.js-show';
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  const slideCount = EL.querySelectorAll('.splide__slide').length;

  const splide = new Splide(EL, {
    type: 'fade',
    pagination: slideCount > 1,
    arrows: slideCount > 1,
    autoplay: true,
    interval: 10000,
    pauseOnHover: false,
    pauseOnFocus: false,
    rewind: true,
    breakpoints: {
      767: {
        arrows: false,
      },
    },
  });

  splide.mount();
});

console.log('ok')
